import { useEffect, useMemo } from "react";
import { useMatch } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { PARTY_SECTION_PATH } from "@/app/constants/routes";
import { useQueryParams } from "@/shared/hooks/use-query-params";
import { getPartySectionLink, PartyRoutes } from "@/shared/routing";
import { usePartiesState } from "@/shared/stores/app-state";

import { BreadCrumbSelectItem } from "../bread-crumb-select-item";
import { BreadCrumbItemProps, MenuItem } from "../types";

const useGetPartiesMenuList = () => {
	const partiesStore = usePartiesState();
	const query = useQueryParams().toString();
	const route = useMatch(PARTY_SECTION_PATH);
	const { section: currentPartySection } = route?.params || {};

	useEffect(() => {
		partiesStore.loadData();
	}, [partiesStore]);

	const menuList = useMemo((): MenuItem[] => {
		const isRedirectToMainSection =
			!currentPartySection ||
			!Object.values(PartyRoutes).includes(currentPartySection as PartyRoutes);
		const newPartySection = isRedirectToMainSection
			? PartyRoutes.Markets
			: (currentPartySection as PartyRoutes);
		const newQuery = !isRedirectToMainSection && query ? `?${query}` : "";

		return partiesStore.partiesList.map(({ partyUUID, partyName }) => {
			const partyLink = getPartySectionLink({ partyUUID, partySection: newPartySection });

			return { value: partyUUID, label: partyName, redirectPath: `${partyLink}${newQuery}` };
		});
	}, [currentPartySection, partiesStore.partiesList, query]);

	return menuList;
};

export const PartyBreadCrumb = observer(({ route, paths }: BreadCrumbItemProps) => {
	const menuList = useGetPartiesMenuList();

	return (
		<BreadCrumbSelectItem route={route} paths={paths} menuList={menuList} popoverWidth={120} />
	);
});
